import AudioMemoControls from './AudioMemoControls';

export default AudioMemoControls;
